import { useState } from "react";
import toast from "react-hot-toast";
import { Spinner } from "flowbite-react";
import Backend from "../../../Backend/Backend";
import { useNavigate } from "react-router-dom";

const backend = await new Backend().init();

const S = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

  .cp {
    min-height: 100vh;
    display: flex; align-items: center; justify-content: center;
    background: var(--background);
    padding: 12px; font-family: 'Inter', sans-serif; box-sizing: border-box;
  }

  .cp-box {
    background: var(--background);
    border: 1px solid var(--hover);
    border-radius: 16px;
    padding: 28px 24px 22px;
    width: 100%; max-width: 380px;
    box-shadow: 0 4px 24px rgba(0,0,0,.08);
  }

  .cp-head { text-align: center; margin-bottom: 22px; }
  .cp-head img { width: 48px; height: 48px; object-fit: contain; margin-bottom: 10px; }
  .cp-head h2 { margin: 0; font-size: 17px; font-weight: 600; color: var(--text); }
  .cp-head p  { margin: 3px 0 0; font-size: 12px; color: var(--subtext); }

  .cp-label {
    display: block; font-size: 11px; font-weight: 500;
    color: var(--subtext); margin-bottom: 5px;
    text-transform: uppercase; letter-spacing: .5px;
  }

  .cp-input {
    width: 100%; height: 42px; padding: 0 12px;
    border: 1px solid var(--hover);
    border-radius: 10px;
    font-size: 13px; color: var(--text);
    background: var(--background);
    outline: none; box-sizing: border-box;
    transition: border-color .18s, background .18s;
    font-family: 'Inter', sans-serif;
  }
  .cp-input:focus { border-color: var(--primary); background: var(--background); }
  .cp-input::placeholder { color: var(--subtext); opacity: .5; }

  .cp-field { margin-bottom: 12px; }

  .cp-btn {
    width: 100%; height: 44px; margin-top: 14px; border: none; border-radius: 10px;
    background: var(--primary); color: #fff;
    font-size: 13px; font-weight: 600; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: opacity .18s; font-family: 'Inter', sans-serif;
  }
  .cp-btn:hover:not(:disabled) { opacity: .85; }
  .cp-btn:disabled { opacity: .35; cursor: not-allowed; }

  .cp-back { text-align: center; margin-top: 14px; font-size: 12px; color: var(--subtext); }
  .cp-back span { color: var(--primary); cursor: pointer; font-weight: 500; }
  .cp-back span:hover { text-decoration: underline; }

  @media (max-width: 400px) {
    .cp-box { padding: 22px 16px 18px; }
  }
`;

export default function CPassword() {
  const navigation = useNavigate();
  const [oldpassword, setOldPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [cofpassword, setCofPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (!document.getElementById("cp-style")) {
    const s = document.createElement("style"); s.id = "cp-style"; s.textContent = S;
    document.head.appendChild(s);
  }

  const isLogin = () => {
    if (!oldpassword) return toast.error("Old password is required!");
    if (!newpassword) return toast.error("New password is required!");
    if (!cofpassword) return toast.error("Please confirm your new password!");
    if (newpassword !== cofpassword) return toast.error("Passwords do not match!");
    setLoading(true);
    backend.cpassword({
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      server: localStorage.getItem("server"),
      username: localStorage.getItem("username"),
      oldpassword, cpassword: newpassword,
    }).then((r) => {
      setLoading(false);
      if (r.error == "False") { toast.success("Password changed successfully!"); navigation("/"); }
      else toast.error(r.message || "Failed to change password!");
    });
  };

  const onKey = (e) => { if (e.key === "Enter") { e.target.blur(); isLogin(); } };

  return (
    <div className="cp">
      <div className="cp-box">

        <div className="cp-head">
          <img src={window.LOGO} alt="logo" />
          <h2>Change Password</h2>
          <p>Set a new password for your account</p>
        </div>

        <div className="cp-field">
          <label className="cp-label">Old Password</label>
          <input className="cp-input" type="password" placeholder="Enter old password"
            value={oldpassword} onChange={(e) => setOldPassword(e.target.value)} onKeyDown={onKey} />
        </div>

        <div className="cp-field">
          <label className="cp-label">New Password</label>
          <input className="cp-input" type="password" placeholder="Enter new password"
            value={newpassword} onChange={(e) => setNewPassword(e.target.value)} onKeyDown={onKey} />
        </div>

        <div className="cp-field">
          <label className="cp-label">Confirm Password</label>
          <input className="cp-input" type="password" placeholder="••••••••"
            value={cofpassword} onChange={(e) => setCofPassword(e.target.value)} onKeyDown={onKey} />
        </div>

        <button className="cp-btn" disabled={loading} onClick={isLogin}>
          {loading ? <Spinner size="sm" /> : "Update Password"}
        </button>

        <div className="cp-back">
          <span onClick={() => navigation("/")}>← Back to Login</span>
        </div>
      </div>
    </div>
  );
}
